(function (angular) {

    'use strict';

    angular.module('app.sgdpppurchase')
        .controller('app.sgdpppurchase.PurchaseFlowController', ['$state',
            function ($state) {
                var vm = this;
                vm.$state = $state;
                vm.tabStates = [
                    'app.sgdpppurchase.plans', 'app.sgdpppurchase.applicants', 'app.sgdpppurchase.payment', 'app.sgdpppurchase.activation'
                ];

                //  functions
                vm.changeTabs = changeTabs;
                vm.isDisabled = isDisabled;

                function changeTabs(newTab) {
                    if (!isDisabled(newTab)) {
                        $state.go(newTab);
                    }
                } 

                function isDisabled(tab) {
                    return vm.tabStates.indexOf(tab) > vm.tabStates.indexOf($state.current.name);
                }
            }]);
})(angular);

